export default "__VITE_ASSET__Uq4Cik9V__"